<span [ngClass]="classes()" class=tooltip> {{word.word}} <div class="top">{{tooltip()}}<i></i> </div></span>